import { render, staticRenderFns } from "./yjxDialog.vue?vue&type=template&id=227cbfb5&scoped=true&"
import script from "./yjxDialog.vue?vue&type=script&lang=js&"
export * from "./yjxDialog.vue?vue&type=script&lang=js&"
import style0 from "./yjxDialog.vue?vue&type=style&index=0&id=227cbfb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227cbfb5",
  null
  
)

export default component.exports